import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createParkingService } from '../../api/parking-service.ts';
import { CreateParkingServiceRequest } from '../../api/requests/parking-service-request.ts';

export default function useCreateParkingService(): UseMutationResult<
  Awaited<ReturnType<typeof createParkingService>>,
  Error,
  CreateParkingServiceRequest
> {
  return useMutation({
    mutationFn: createParkingService,
  });
}
